import { render, staticRenderFns } from "./long-title.vue?vue&type=template&id=5dffaa88&scoped=true"
import script from "./long-title.vue?vue&type=script&lang=js"
export * from "./long-title.vue?vue&type=script&lang=js"
import style0 from "./long-title.vue?vue&type=style&index=0&id=5dffaa88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dffaa88",
  null
  
)

export default component.exports